import script from "./iniReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./iniReceipt.vue?vue&type=script&setup=true&lang=js"

import "./iniReceipt.vue?vue&type=style&index=0&id=1967d8f6&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1967d8f6"]])

export default __exports__